import { Select } from "antd";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import StandingList from "~pages/Standings/components/StandingList";
import StandingsPool from "~pages/Standings/components/StandingsPool";
import { GroupingStagePool } from "~pages/Standings/enums/groupingStagePool";
import type { StandingTransformed } from "~pages/Standings/types/standingTransformed";
import type { TransformedResult } from "~pages/Standings/types/transformedResult";

type Props = {
  stages: Array<TransformedResult<StandingTransformed | TransformedResult<StandingTransformed>>> | undefined;
  grouping: GroupingStagePool;
  selectedColumns: string[];
};

const StandingsStage = ({ stages, grouping, selectedColumns }: Props) => {
  const options = stages?.map((item) => ({
    label: item.entity?.name || "",
    value: item.entity?.id || "",
  }));
  const [currentStage, setCurrentStage] = useState<string | undefined>(options?.[0]?.value);

  if (!options) {
    return null;
  }

  const data = stages?.find((st) => st.entity?.id === currentStage)?.values || [];

  return (
    <>
      {options.length > 0 && (
        <span style={{ order: 1 }}>
          <FormattedMessage id={"stage"} />:
          <Select
            value={currentStage}
            onSelect={(value) => setCurrentStage(value)}
            style={{ width: 200, marginLeft: 10 }}
            options={options}
          />
        </span>
      )}
      <span style={{ flexBasis: "100%", order: 4, width: "100%" }}>
        {currentStage && currentStage !== "noKeyData" && (
          <>
            {grouping === GroupingStagePool.StagePool && (
              <StandingsPool selectedColumns={selectedColumns} pools={data as Array<TransformedResult<StandingTransformed>>} />
            )}
            {grouping === GroupingStagePool.Stage && (
              <StandingList selectedColumns={selectedColumns} data={data as Array<StandingTransformed>} />
            )}
          </>
        )}
        {(!currentStage || currentStage === "noKeyData") && (
          <StandingList selectedColumns={selectedColumns} data={data as Array<StandingTransformed>} />
        )}
      </span>
    </>
  );
};

export default StandingsStage;
